<template>
  <div id="data-list-list-view">
    <!-- searchSheet -->
    <vx-card class="margin-bottom" title="筛选搜索"  noShadow cardBorder collapseAction>
      <vs-row vs-type="flex">
        <vs-col
          vs-order="1"
          vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>选择班级</span>
            <v-select
              class="inline-block margin width-100"
              v-model="searchSheetData.classroom"
              label="name"
              :options="classList"
            />
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>用 户 名</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.username"/>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>姓 名</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.name"/>
        </vs-col>
        <!-- <vs-col
          vs-order="4"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>手机号码</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.phone"/>
        </vs-col>
        <vs-col
          vs-order="5"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>激活状态</span>
            <v-select
              class="inline-block margin width-100"
              v-model="searchSheetData.status"
              label="name"
              :options="stuentStatusList"
            />
        </vs-col> -->
      </vs-row>
      <vs-row vs-type="flex">
        <vs-col
          vs-order="1"
          vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
            <span>添加时间</span>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.activeBeginDate"
              class="form-control margin" 
              placeholder="开始时间">
            </flat-pickr>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.activeEndDate"
              class="form-control margin" 
              placeholder="结束时间">
            </flat-pickr>
        </vs-col>
        <vs-col
          vs-order="1"
          vs-type="flex" vs-justify="flex-start" vs-align="center"  vs-lg="6" vs-sm="12" vs-xs="12">
            <span>注册时间</span>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.registerBeginDate"
              class="form-control margin" 
              placeholder="开始时间">
            </flat-pickr>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.registerEndDate"
              class="form-control margin" 
              placeholder="结束时间">
            </flat-pickr>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1 mb-base">
          <vs-button class="margin" color="primary" type="filled" @click="requestSearch">搜索</vs-button>
          <vs-button class="margin" color="warning" type="border" @click="resetSearch">重置</vs-button>
        </div>
      </div>
    </vx-card>
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="list" :hoverFlat="true">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ADD NEW -->
        <!-- <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">新建班级</span>
        </div> -->
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
          <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} of {{ list.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th>序号</vs-th>
        <vs-th>姓名</vs-th>
        <vs-th>用户名</vs-th>
        <vs-th>所属班级</vs-th>
        <vs-th>添加时间</vs-th>
        <vs-th>注册时间</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ indextr + 1 }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.user.username }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.class.name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.create_time }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.user.create_time }}</p>
            </vs-td>
            <vs-td>
              <vs-button color="primary" size="small" type="filled" @click="showSetStudentName(tr)">设置姓名</vs-button>
              <vs-button class="ml-4" color="warning" size="small" type="filled" @click="showResetPasswordPrompt(tr)">重置密码</vs-button>
              <vs-button class="ml-4" color="danger" size="small" type="filled" @click="showDeleteStudent(tr)">删除学生</vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- set name -->
    <vs-prompt
      vs-title="设置姓名"
      vs-accept-text="确定"
      vs-cancel-text="取消"
      :vs-active.sync="setName"
      @vs-close="closeSetName"
      @vs-accept="setStuName"
      @vs-cancel="closeSetName"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <span>请输入学生姓名</span>
          <vs-input v-model="currentStuName" class="mt-3 w-full" />
        </div>
      </div>
    </vs-prompt>

    <!-- reset password -->
    <vs-prompt
      vs-title="重置密码"
      :vs-buttons-hidden="true"
      :vs-active.sync="resetPassword"
      @vs-close="closeResetPassword"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <p v-if="!isMakeSureReset">确认重置密码？</p>
          <div v-else>
            <p>学生账号为：{{account}}</p>
            <p>重置后的密码为：{{password}}</p>
          </div>
          <div class="mt-3" v-if="!isMakeSureReset">
            <vs-button color="primary" size="small" type="filled" @click="sureResetPassword">确定</vs-button>
            <vs-button class="margin" color="warning" size="small" type="border" @click="closeResetPassword">取消</vs-button>
          </div>
          <div v-else>
            <vs-button class="margin-top" size="small" type="filled" @click="closeResetPassword">确定</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>

    <!-- delete student -->
    <vs-prompt
      vs-title="删除学生"
      :vs-buttons-hidden="true"
      :vs-active.sync="deleteStudent"
      @vs-close="closeDetaleStudentPrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <p>是否确定删除该学生？</p>
          <p class="tip">删除后该学生将无法进入HAAI学堂教学平台，您将看不到</p>
          <p class="tip">该学生的信息、作品等数据</p>
          <div class="mt-3">
            <vs-button color="primary" size="small" type="filled" @click="makeSureDelete">确定</vs-button>
            <vs-button class="margin" color="warning" size="small" type="border" @click="closeDetaleStudentPrompt">取消</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>

import { 
  studentList, 
  classList, 
  studentResetPassword, 
  removeStudentsFromClass, 
  setStudentName,
} from '@/api/school';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';

export default {
  components: {
  },
  data() {
    return {
      classId: 0,
      list: [],
      classList: [{id: 0, name: "全部"}],
      stuentStatusList: [{id: 0,name: "全部"},{id: 1,name: "未激活"},{id: 2,name: "已激活"}],
      searchSheetData: {
        classroom: {id: 0, name: "全部"},
        username: "",
        name: "",
        phone: "",
        status: {id: 0,name: "全部"},
        activeBeginDate: null,
        activeEndDate: null,
        registerBeginDate: null,
        registerEndDate: null
      },
      itemsPerPage: 5,
      isMounted: false,
      addNewDataSidebar: false,
      resetPassword: false,
      deleteStudent: false,
      isMakeSureReset: false,
      isMakeSureDelete: false,
      currentStuId: 0,
      currentClassId: 0,
      currentStuName: '',
      account: null,
      password: '08980899', // 重置后的密码
      setName: false,
    }
  },
  created() {
    
  },
  mounted() {
    this.classId = this.$route.query.id ? this.$route.query.id: 0
    this.isMounted = true
    this.init()
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
    init() {
      studentList({class_id: this.classId}).then(res => {
        if (res.code == 1) {
          this.list = res.data.list
        }
      });
      this.getClassList();
    },
    getClassList() {
      classList().then((res) => {
        if (res.code == 1) {
          this.classList =  this.classList.concat(res.data.list);
        }
      });
    },
    requestSearch() {
      console.log(this.searchSheetData);
      // 提交搜索表单
    },
    resetSearch() {
      this.searchSheetData = {
        classroom: {id: 0, name: "全部"},
        username: "",
        name: "",
        phone: "",
        status: {id: 0,name: "全部"},
        activeBeginDate: null,
        activeEndDate: null,
        registerBeginDate: null,
        registerEndDate: null
      };
      this.init();
    },
    showResetPasswordPrompt(row) {
      this.account = row.user.username
      this.currentStuId = row.id
      this.currentClassId = row.class_id
      this.isMakeSureReset = false;
      this.resetPassword = true;
    },
    closeResetPassword() {
      this.resetPassword = false;
    },
    sureResetPassword() {
      studentResetPassword({
        class_id: this.currentClassId,
        student_id: this.currentStuId
      }).then(res => {
        if (res.code == 1) {
          this.isMakeSureReset = true;
          this.$vs.notify({
            color: "success",
            text: "操作成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      })
    },
    showDeleteStudent(row) {
      this.currentStuId = row.id
      this.currentClassId = row.class_id
      this.deleteStudent = true;
    },
    closeDetaleStudentPrompt() {
      this.deleteStudent = false;
    },
    makeSureDelete() {
      let temp = []
      temp.push(this.currentStuId)
      removeStudentsFromClass({
        class_id: this.currentClassId,
        students: temp
      }).then(res => {
        if (res.code == 1) {
          this.isMakeSureReset = true;
          // 确认删除学生
          this.$vs.notify({
            color: "success",
            text: "删除学生成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.closeDetaleStudentPrompt();
          this.init()
        }
      })
    },
    showSetStudentName(row) {
      this.currentStuId = row.id
      this.currentStuName = row.name
      this.currentClassId = row.class_id
      this.setName = true
    },
    setStuName() {
      setStudentName({
        class_id: this.currentClassId,
        student_id: this.currentStuId,
        name: this.currentStuName,
      }).then(res => {
        if (res.code == 1) {
          this.isMakeSureReset = true;
          // 确认删除学生
          this.$vs.notify({
            color: "success",
            text: "操作成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.closeSetName();
          this.init()
        }
      })
    },
    closeSetName() {
      this.setName = false
    }
  },
  components: {
    flatPickr,
    vSelect
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/_variables.scss";

#data-list-list-view {
  white-space: nowrap;
}
.margin{
  margin: 0 0 0 1rem;
}
.margin-top{
  margin-top: 20px;
}
.width-100{
  width: 100% !important;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-con-input-label{
  width: 100%;
}
.tip{
  font-size: $font-size-small;
  color: $danger;
}
</style>
